import { useRef } from 'react';

import { useRoute } from 'hooks/navigation/use-route';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { isSectionRoute, routes, routesForTopServiceModeDisplay } from 'utils/routing';

export const useRoutesDisplayBottomService = (): boolean => {
  const enableFixedAddToOrderAndQuantityButton = useFlag(
    LaunchDarklyFlag.ENABLE_FIXED_ADD_TO_ORDER_AND_QUANTITY_BUTTON
  );

  const resolutionMap = useRef(new Map());

  const isDesktop = useIsDesktopBreakpoint();
  const { pathname } = useRoute();

  const routeKey = `${pathname}-${isDesktop}-${enableFixedAddToOrderAndQuantityButton}`;

  if (!resolutionMap.current.has(routeKey)) {
    const shouldShowFromRoutesForServiceMode = routesForTopServiceModeDisplay.some(
      ({ route, exact }) => {
        if (enableFixedAddToOrderAndQuantityButton && !isDesktop && route === routes.menu) {
          // when not on desktop, only show TSM on base menu or section routes, not item / combo / picker
          return pathname === routes.menu || isSectionRoute(pathname);
        }

        return exact ? pathname === route : pathname.startsWith(route);
      }
    );
    resolutionMap.current.set(routeKey, shouldShowFromRoutesForServiceMode);
  }

  return resolutionMap.current.get(routeKey);
};
